// Bootstrap must be the first stylesheet so the cascade order matches the previous
// <link> in index.html (Bootstrap first, then app styles). It is bundled into the
// hashed CSS asset instead of being fetched from jsDelivr on every page load.
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'focus-visible';
// Quill's stylesheet is only used by lazily loaded admin/partner editors, but it must
// stay *before* the Tailwind utilities in index.css (as it was when everything lived in
// one bundle) so utility overrides such as `[&_.ql-toolbar]:py-0` keep winning the
// cascade. Importing it here keeps it in the main stylesheet at its original position.
import 'react-quill-new/dist/quill.snow.css';
import './index.css';
import './styles/scrollbar.css';
import './styles/night.css';
import 'react-toastify/dist/ReactToastify.css';

// Helper script to track input modality (mouse vs keyboard)
document.addEventListener('DOMContentLoaded', () => {
    let hadKeyboardEvent = false;
    const keyboardModalityWhitelist = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Space', 'Escape', 'Home', 'End', 'PageUp', 'PageDown'];

    document.addEventListener('keydown', (e) => {
        // Disabled - no longer tracking keyboard events for focus styles
        hadKeyboardEvent = false;
    });

    // If mouse is used, cancel keyboard modality
    document.addEventListener('mousedown', () => {
        hadKeyboardEvent = false;
        // Ensure user-is-tabbing class is removed
        document.body.classList.remove('user-is-tabbing');
    });

    // Disable adding the class to indicate keyboard navigation
    document.addEventListener('focusin', (e) => {
        // Always remove the class to disable focus styles
        document.body.classList.remove('user-is-tabbing');
    });

    document.addEventListener('focusout', () => {
        document.body.classList.remove('user-is-tabbing');
    });
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
